import gql from 'graphql-tag';

export const ADD_BULK_PAYMENT_BUDGET_DATA = gql`
  mutation AddBulkPaymentBudgetData($bulkPaymentBudgetData: SaveBulkPaymentBudgetData!) {
    saved: saveBulkPaymentBudgetData(bulkPaymentBudgetData: $bulkPaymentBudgetData)
  }
`;
